import { useTranslation } from "react-i18next";
// Components
import { HeaderMainDiv, Title } from "./styles";

const EvaluationsHeader = () => {
  const [t] = useTranslation("global");

  return (
    <HeaderMainDiv>
      <Title>{t("evaluation").toUpperCase()}</Title>
    </HeaderMainDiv>
  );
};

export default EvaluationsHeader;
